import { Directive, input } from '@angular/core';
import { ControlContainer, ControlValueAccessor } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';

@Directive()
export abstract class FormFieldComponent<T> implements ControlValueAccessor {
  readonly formControlName = input<string>(undefined);
  readonly label = input<string>(undefined);
  readonly placeholder = input<string>(undefined);
  readonly validationMessages = input<{
    [key: string]: string;
  }>({}); // Custom validation messages

  onChange = (_: T) => {};
  onTouched = () => {};

  protected _value: T;

  constructor(
    private controlContainer: ControlContainer,
    public translate: TranslateService,
  ) {}

  // get hold of FormControl instance in parent FormGroup
  get control() {
    return this.controlContainer.control?.get(this.formControlName());
  }

  getErrorMessage() {
    if (this.control?.errors) {
      for (const errorKey in this.control.errors) {
        // Use custom validation messages if available
        const validationMessages = this.validationMessages();
        if (validationMessages[errorKey]) {
          return validationMessages[errorKey];
        }

        // Default error messages
        switch (errorKey) {
          case 'required':
            return this.translate.instant('SHARED.ERRORS.VALIDATION.REQUIRED', {
              field: this.label(),
            });
          default:
            return this.translate.instant('SHARED.ERRORS.VALIDATION.DEFAULT', {
              field: this.label(),
            });
        }
      }
    }
    return null;
  }

  // ControlValueAccessor methods
  registerOnChange(fn: (_: any) => void) {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void) {
    this.onTouched = fn;
  }

  abstract writeValue(value: T);
  // --
}
